import React, { Component } from "react"

/* Components */
import { Chip } from '../components'

/* CONSTANTS */
import { env, utils } from "../constants"
import { CHOICE } from "../constants/status"

const rateData = {
    "ante": { text: "BET", style: {} },
    "perfectpair": { text: "PP", style: { marginBottom: 8, marginRight: 8, position: 'absolute' } },
    "twentyone": { text: "21+3", style: { marginTop: 8, marginRight: 8 } },
    "bust": { text: "BUST", style: { marginTop: 8, marginLeft: 8 } },
    "crazyseven": { text: "CRAZY", style: { marginBottom: 8, marginLeft: 8 } }
}

/* FIELDS */
const tempBoxStake = { ante: 0, perfectpair: 0, twentyone: 0, crazyseven: 0, bust: 0 }

class Rates extends Component {

    /* Get Color */
    getColor = value => {

        const { chips } = this.props

        let color = chips[0].color

        chips.forEach(item => {
            if (item.value <= value) {
                color = item.color
            }
        })

        return color
    }

    /* DRAW ANIMATION */
    _animation = (target) => {

        const { list } = this.props

        return (
            <div className="animated-chips">
                {list.map((chip, index) => {
                    const color = this.getColor(chip.value)

                    if (chip.place === target && !chip.removed) {
                        return (
                            <div className={`animated-chip ${chip.type === "add" ? "visible" : "hidden"}`} key={`${index}`}>
                                <Chip color={color} value={chip.value} />
                            </div>
                        )
                    }

                    return null
                })}
            </div>
        )
    }

    add = (target, box) => {

        const { stakes, boxPlayers, playerId, status, chips, selected, balance, game, setStakes, list, total, setList } = this.props

        let tempStakes = [...stakes]

        if (boxPlayers && boxPlayers[box] && boxPlayers[box].playerId === playerId && stakes && stakes[box] && status === CHOICE && chips[selected]) {

            let stake = { ...tempStakes[box] }
            const value = chips[selected].value

            if (target === "ante") {
                stake.ante += value
            } else {
                if (!stake.ante) {
                    return
                }
                if (target === 'perfectpair') {
                    stake.perfectpair += value
                } else if (target === 'twentyone') {
                    stake.twentyone += value
                } else if (target === 'bust') {
                    stake.bust += value
                } else {
                    stake.crazyseven += value
                }
            }

            if ((total + value) > balance) {
                utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
                return
            }

            if (stake.ante > game.max) {
                utils.toggleError(`${utils.translate("Maximum bid")} ${game.max}`, "error", "maxbidante")
                return
            }

            if (stake.perfectpair > game.maxPerfectPair) {
                utils.toggleError(`${utils.translate("Maximum bid for PERFECT PAIR")} ${game.maxPerfectPair}`, "error", "maxbidPP")
                return
            }

            if (stake.twentyone > game.maxTwentyOne) {
                utils.toggleError(`${utils.translate("Maximum bid for 21+3")} ${game.maxTwentyOne}`, "error", "maxbidTO")
                return
            }

            if (stake.bust > game.maxBust) {
                utils.toggleError(`${utils.translate("Maximum bid for BUST")} ${game.maxBust}`, "error", "maxbidb")
                return
            }

            if (stake.crazyseven > game.maxCrazySeven) {
                utils.toggleError(`${utils.translate("Maximum bid for CRAZY SEVEN")} ${game.maxCrazySeven}`, "error", "maxbidcs")
                return
            }

            list.push({ value, type: "add", target, place: `${target}-${box}`, box })
            setList(list)

            tempStakes[box] = stake
            setStakes(tempStakes)

        }
    }

    _chip = (type, box) => {
        const { stakes, result, ppResult, twentyoneResult, crazySevenResult, bustResult, blackjack } = this.props

        const boxStake = stakes[box] ? stakes[box] : { ...tempBoxStake }

        const typeResult = type === "ante" ? result : type === "perfectpair" ? ppResult : type === "twentyone" ? twentyoneResult : type === "crazyseven" ? crazySevenResult : bustResult
        const boxResult = typeResult && typeResult[box] ? typeResult[box] : null

        const value = boxStake[type] ? boxStake[type] : 0
        const color = this.getColor(value)

        const text = rateData[type] ? rateData[type].text : ""
        let style = rateData[type] ? rateData[type].style : {}

        const size = type === 'ante' ? 75 : 65

        let isHidden = type === "ante" ? (boxResult && (boxResult.text === "lose" || !boxResult.ante) && !boxResult.surrender) : boxResult && boxResult.multiplier === 0
        if (type === "bust") {
            isHidden = isHidden && (blackjack && !blackjack[box])
        }

        if (isHidden) {
            style = { ...style, opacity: 0 }
        }

        return (
            <div className={`game-chip-outer ${type}`}>
                {
                    value ?
                        <div className={`game-chip`} style={style}>
                            <div className={`game-chip-box ${(isHidden) ? "fold" : "hidden"}`}>{value ? <Chip size={size} color={color} value={value} /> : null}</div>
                            {this._animation(`${type}-${box}`)}
                            {this._winRate(type, box)}
                        </div>
                        : null
                }
                <div className={type === 'ante' ? 'ante-text' : 'bonus-text'}>{text}</div>
            </div>
        )

    }

    /* ANTE & BONUS MULTIPLIER */
    _winRate = (type, box) => {

        const { stakes, result, ppResult, twentyoneResult, crazySevenResult, bustResult } = this.props

        const boxStake = stakes[box] ? stakes[box] : { ...tempBoxStake }
        const typeResult = type === "ante" ? result : type === "perfectpair" ? ppResult : type === "twentyone" ? twentyoneResult : type === "crazyseven" ? crazySevenResult : bustResult
        const boxResult = typeResult && typeResult[box] ? typeResult[box] : null
        const size = type === 'ante' ? 75 : 65
        let isWinRate = boxResult && (boxResult.multiplier || boxResult.text === 'win')

        if (isWinRate) {

            const value = type === 'ante' ? boxResult.rateSum : boxStake[type] * (boxResult.multiplier + 1)
            const multiplier = `${boxResult.multiplier}x`
            const color = this.getColor(value)

            return (
                <div className="rate-win">
                    {boxResult.multiplier ? <div className={`rate-win-text ${type}`}>{multiplier}</div> : null}
                    <div className={`rate-win-chip`}>
                        <Chip size={size} color={color} value={value} />
                    </div>
                </div>
            )
        }
    }


    _rate = (box, isActive = false) => {

        const { status, stakes } = this.props

        let style = ''

        if (isActive) {
            style = 'active'
        }

        const isChoice = isActive && status === CHOICE
        const boxStake = stakes[box] ? stakes[box] : { ...tempBoxStake }

        const bonusActive = boxStake && boxStake.ante ? "bonus-active" : ""

        return (
            <div className={`rate ${style} ${isChoice ? "rate-choice" : ""}`}>
                <div className={`bonus-block ${bonusActive} pp`} onClick={() => this.add('perfectpair', box)}>
                    {this._chip('perfectpair', box)}
                </div>
                <div className={`bonus-block ${bonusActive} cs`} onClick={() => this.add('crazyseven', box)}>
                    {this._chip('crazyseven', box)}
                </div>
                <div className={`bonus-block ${bonusActive} to`} onClick={() => this.add('twentyone', box)}>
                    {this._chip('twentyone', box)}
                </div>
                <div className={`bonus-block ${bonusActive} bust`} onClick={() => this.add('bust', box)}>
                    {this._chip('bust', box)}
                </div>
                <div className="ante-block" onClick={() => this.add('ante', box)}>
                    {this._chip('ante', box)}
                </div>
            </div>
        )

    }

    _boxRender = (box) => {

        const { status, boxPlayers, stakes, playerId, boxJoin, boxLeft, renderCards } = this.props

        const isActive = boxPlayers && boxPlayers[box] && boxPlayers[box].playerId === playerId
        const boxStakeAnte = stakes[box] ? stakes[box].ante : tempBoxStake.ante

        const name = boxPlayers && boxPlayers[box] && boxPlayers[box].name

        const choice = status === CHOICE

        if (!boxPlayers || (boxPlayers && !boxPlayers[box])) {
            return (
                <div className="rate-block-inner" onClick={() => boxJoin(box)}>
                    <div className="rate-join">
                        <img src={`${env.endpoint}/images/rate/arrow.png`} alt="arrow" />
                    </div>
                </div>
            )
        }

        return (
            <div className={`rate-block-inner ${choice ? "inner-choice" : ""} ${isActive ? "active" : ""}`}>
                {this._rate(box, isActive)}
                <div className="player-name">
                    {name}
                    {
                        isActive && (choice || (!choice && !boxStakeAnte)) ?
                            <div className="logout" onClick={() => boxLeft(box)}>
                                <img src={`${env.endpoint}/images/rate/close.png`} alt="close" />
                            </div>
                            : null
                    }

                </div>

                {renderCards(box)}
            </div>
        )

    }

    render = () => {

        const { status } = this.props

        let style = ''

        if (status === CHOICE) {
            style += ' rate-choice'
        } else {
            style += ' rates-game'
        }

        return (
            <div className={`rates ${style}`}>
                <div className={`rate-block ${style} third right`}>{this._boxRender(0)}</div>
                <div className={`rate-block ${style} second right`}>{this._boxRender(1)}</div>
                <div className={`rate-block ${style}`}>{this._boxRender(2)}</div>
                <div className={`rate-block ${style} second left`}>{this._boxRender(3)}</div>
                <div className={`rate-block ${style} third left`}>{this._boxRender(4)}</div>
            </div>
        )

    }

}

export default Rates